module.exports = __webpack_public_path__ + "img/CandaceStone_Pixabay400.10dfe6a6.png";